<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height pa-0 background" fluid>
        <v-col offset-sm="1" sm="10">
          <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card fill-height class="elevation-12" color="color">
                <v-col class="d-flex justify-center">
                  <v-avatar size="200" max-height="100px" tile>
                    <v-img
                      src="../assets/imgs/bmp/logo.svg"
                      height="100%"
                      contain
                    />
                  </v-avatar>
                </v-col>
                <v-card-text>
                  <v-alert color="primary" text>
                    <p class="text-wrap" style="word-break: break-all">
                      Para logar no sistema, é necessário utilizar a url de
                      acesso do parceiro.
                    </p>
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    title: 'BMP'
  },
  data () {
    return {};
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA';
    },
  },
  beforeRouteEnter (to, from, next) {
    if (sessionStorage.isLoginToken === 'true') {
      next({ path: '/sessao-expirada' })
    }
    next()
  }
};
</script>
<style>
.background {
  background-image: url(../assets/imgs/bmp/background.svg);
  background-position: center center;
  background-size: cover;
}
</style>
